<div [ngSwitch]="countdownType">
  <div *ngSwitchCase="countdownTypes.ROUND" class="" class="countdown countdown-round">
    <div class="circle-wrapper">
      <div class="circle">
        <svg
          class="circle-svg"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 300 300"
          xml:space="preserve"
        >
          <circle
            class="circle"
            cx="150"
            cy="150"
            r="149"
            stroke="currentColor"
            stroke-width="2"
            fill-opacity="0"
          ></circle>
          <circle
            [style.stroke-dashoffset]="strokeOffset"
            style="stroke-dasharray: 904"
            class="circle"
            cx="150"
            cy="150"
            r="144"
            stroke="#22ACED"
            stroke-width="2"
            fill-opacity="0"
          ></circle>
        </svg>
      </div>
    </div>
    <div class="livein-container">
      <span *ngIf="preCountdownText || countdownLabel" class="livein copy-m">
        {{ preCountdownText || countdownLabel }}
      </span>
    </div>
    <div class="circle-timer-content">
      <ng-container *ngTemplateOutlet="fullTimeTpl"></ng-container>
    </div>
  </div>

  <div *ngSwitchCase="countdownTypes.FLAT" class="" class="countdown countdown-flat">
    <span *ngIf="preCountdownText || countdownLabel" class="livein copy-m">
      {{ preCountdownText || countdownLabel }}
    </span>
    <div class="indicator-wrapper">
      <div class="indicator-base"></div>
      <div class="indicator" [style.width.%]="indicatorPercent"></div>
    </div>
    <ng-container *ngTemplateOutlet="fullTimeTpl"></ng-container>
  </div>

  <div *ngSwitchCase="countdownTypes.FULL" class="countdown countdown-full">
    <mb-small-spinner></mb-small-spinner>
    <span *ngIf="preCountdownText || countdownLabel" class="livein copy-m">
      {{ preCountdownText || countdownLabel }}
    </span>
    <ng-container *ngTemplateOutlet="fullTimeTpl"></ng-container>
  </div>

  <div *ngSwitchCase="countdownTypes.DAYS" class="days countdown-days">
    <mb-small-spinner></mb-small-spinner>
    <span *ngIf="preCountdownText || countdownLabel" class="livein copy-s">
      {{ preCountdownText || countdownLabel }}
    </span>
    <div class="time-item">
      <span class="time-field">
        <mb-countdown-time [time]="days" [class.three-digits-days]="(days + '').length === 3"></mb-countdown-time>
      </span>
      <span class="time-label">{{ (days === 1 ? 'DAY' : 'DAYS') | translate }}</span>
    </div>
  </div>
</div>

<ng-template #fullTimeTpl>
  <mb-countdown-time-fields
    [hideRedundant]="hideRedundant"
    [days]="days"
    [hours]="hours"
    [minutes]="minutes"
    [seconds]="seconds"
  ></mb-countdown-time-fields>
</ng-template>
